import React, { useEffect, useState } from "react"

import "./Sidebar.css"

import logo from "../../Assets/Images/clinica-prime-logo-dark.png"
import collapsedLogo from "../../Assets/Images/clinica-prime-icon.png"
import LogoutModal from "../Commons/LogoutModal"

import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
} from "react-pro-sidebar"

import {
  // adminMenu,
  directorMenu,
  specialistMenu,
  PCPMenu,
  nurseMenu,
  residentMenu,
  laboratoryMenu,
  supervisorMenu,
} from "./Menu/Menu.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MenuOutlined, ArrowLeftOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import { menuStyles } from "./Themes"
import { Col, Container, Row } from "react-bootstrap"
import { faCircleUser } from "@fortawesome/free-solid-svg-icons"
import { getName, getRole, refreshPage } from "../Helpers/Utilities/Common"

function SidebarMenu(props) {
  const navigateto = useNavigate()
  const { collapseSidebar, collapsed } = useProSidebar()
  const [menuList, setMenuList] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [showBars, setShowBars] = useState(false)

  // Function to show logout modal
  const handleLogout = () => {
    setIsModalVisible(true)
  }

  // Function show sidebar
  const handleShowSidebar = () => {
    collapseSidebar()
    setShowBars(!showBars)
  }

  // Function to remove logout modal
  const handleModalCancel = () => {
    setIsModalVisible(false)
  }

 // to show what type of sidebar will show
  useEffect(() => {
    const role = getRole();

    switch (role) {
      case "director":
        setMenuList(directorMenu);
        break;
      case "specialist":
        setMenuList(specialistMenu);
        break;
      case "pcp":
        setMenuList(PCPMenu);
        break;
      case "resident":
        setMenuList(residentMenu);
        break;
      case "nurse":
        setMenuList(nurseMenu);
        break;
      case "laboratory":
        setMenuList(laboratoryMenu);
        break;
      case "supervisor":
        setMenuList(supervisorMenu);
        break;
      default:
        localStorage.clear();
        refreshPage();
        break;
    }
  }, []);


  return (
    <>
      <div className="center burger-icon" onClick={handleShowSidebar}>
        {showBars ? (
          <ArrowLeftOutlined className="icon-bars" />
        ) : (
          <MenuOutlined className="icon-bars" />
        )}
      </div>
      <Sidebar
        backgroundColor="var(--sidebar-color)"
        defaultCollapsed
        className={showBars ? "" : "sidebar"}
        // onMouseEnter={showBars ? null : () => collapseSidebar()}
        // onMouseLeave={showBars ? null : () => collapseSidebar()}
      >
        {/* <div className="center bg-white">
          <img src={logo} className="logo-duplicate mt-2" alt="logo" />
          <img
            src={logo}
            className="logo-sidebar mt-2"
            alt="logo"
            onClick={() => collapseSidebar()}
          />
        </div> */}
        <div className="center bg-white pe-1 d-flex flex-column">
          <img src={logo} className="logo-duplicate mt-2" alt="logo" />
          <img
            src={collapsed ? collapsedLogo : logo}
            className={`logo-sidebar mt-2 ${collapsed ? "collapsed-logo" : ""}`}
            alt="logo"
            onClick={() => collapseSidebar()}
          />
          <span>Yakap</span>
        </div>
        <Menu
          className="mt-2 margin-3"
          menuItemStyles={{
            button: ({ level, active, disabled }) => {
              // only apply styles on first level elements of the tree
              return {
                color: active ? "black !important" : "white",
                backgroundColor: active ? "var(--sidebar-active)" : undefined,
              }
            },
          }}
        >
          {menuList.map((menuItem) => {
            if (menuItem.submenu) {
              return (
                <SubMenu
                  active={menuItem.menu === props.active}
                  icon={
                    <FontAwesomeIcon
                      icon={menuItem.iconName}
                      // color="whitesmoke"
                      className="icon"
                    />
                  }
                  label={menuItem.menu}
                  rootStyles={menuStyles}
                >
                  {menuItem.submenu.map((subItem) => {
                    return (
                      <MenuItem
                        active={subItem.sub === props.active_sub}
                        onClick={() => navigateto(subItem.to)}
                        // rootStyles={subMenuStyles}
                      >
                        {subItem.sub}
                      </MenuItem>
                    )
                  })}
                </SubMenu>
              )
            } else {
              if (menuItem.to !== "") {
                return (
                  <MenuItem
                    active={menuItem.menu === props.active}
                    onClick={() => navigateto(menuItem.to)}
                    icon={
                      <FontAwesomeIcon
                        icon={menuItem.iconName}
                        // color="whitesmoke"
                        className="icon"
                      />
                    }
                    rootStyles={menuStyles}
                  >
                    {menuItem.menu}
                  </MenuItem>
                )
              } else {
                return (
                  <MenuItem
                    onClick={handleLogout}
                    icon={
                      <FontAwesomeIcon
                        icon={menuItem.iconName}
                        // color="whitesmoke"
                        className="icon"
                      />
                    }
                    rootStyles={menuStyles}
                  >
                    {menuItem.menu}
                  </MenuItem>
                )
              }
            }
          })}
        </Menu>

        {!collapsed && (
          <Container
            style={{
              position: "relative",
              bottom: 0,
              paddingBottom: 20,
              paddingTop: 20,
              transition: "ease-out",
              transitionDelay: 0.3,
              backgroundColor: "var(--sidebar-color)",
            }}
          >
            <Row>
              <Col xs={2}>
                <FontAwesomeIcon
                  fontSize={30}
                  icon={faCircleUser}
                  color="white"
                />
              </Col>
              <Col>
                <h6 className="p-0 m-0 text-white">{getName()}</h6>
                <small className="p-0 m-0 text-white">{getRole()}</small>
              </Col>
            </Row>
          </Container>
        )}
        <LogoutModal visible={isModalVisible} onCancel={handleModalCancel} />
      </Sidebar>
    </>
  )
}

export default SidebarMenu
